import { FilterItem } from './filter-item';

export class FilterOptions {
    constructor(
        public readonly filterItems: Array<FilterItem>
    ) {
    }

    hasValues(): boolean {
        return this.filterItems.some(item => item.value !== '');
    }

    setValues(record: Record<string, string>) : void {
        this.filterItems.forEach(item => item.value = record[item.key]);
    }

    clear(): void {
        this.filterItems.forEach(item => item.value = '');
    }

    toRecord(): Record<string, string> {
        let record: Record<string, string> = {};
        this.filterItems.forEach(item => record[item.key] = item.value);
        return record;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/domain/filter/filter-options.ts